import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { Router } from '@angular/router';
import { AuthService } from '../auth/auth.service';
import { LocalstorageService } from '../shared/localstorage/localstorage.service';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  constructor(
    private router: Router,
    private authService: AuthService,
    private localStorageService: LocalstorageService,
  ) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(catchError(error => this.handleError(error)));
  }

  handleError(error: HttpErrorResponse) {
    let url = this.router.url.split('?')[0];
    if (error.status === 401 && url != '/reset-password') {
      this.localStorageService.removeItem('userId');
      this.localStorageService.removeItem('user');
      this.localStorageService.removeItem('token');
      this.authService.logout();
      this.router.navigateByUrl('/');
    }
    return throwError(error);
  }
}
